module.exports = __webpack_public_path__ + "img/20200408143138025.a1ef7cf6.png";